import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ImageUtils } from "../../../core/utils/image-utils";
import { LogService } from "../../../core/services/log.service";
import { EnvironmentConfig, Image } from "../../../core/core";

declare const environment: EnvironmentConfig;
@Component({
  selector: "common-image-preview-upload",
  templateUrl: "./image-preview-upload.component.html",
  styleUrls: ["./image-preview-upload.component.scss"],
})
export class ImagePreviewUploadComponent {
  @Input() rt: string;
  @Input() expectedOrientation: "Landscape" | "Portrait";
  @Input() expectedOrientationMessage: string;
  @Input() imageBlob: Blob | Image | any;

  imgURL: SafeUrl;
  message: string;
  resizedImage;

  @ViewChild("imageButton") imageButton: ElementRef;
  @Output() imageBlobChange = new EventEmitter<Blob>();

  constructor(private sanitizer: DomSanitizer, private logService: LogService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    if (this.imageBlob) {
      if (this.imageBlob.storagePath) {
        this.imgURL = environment.baseImagePath + "/" + this.imageBlob.storagePath;
        return;
      }

      try {
        const objectUrl = window.URL.createObjectURL(this.imageBlob);
        this.imgURL = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      } catch (e) {}
    }
  }

  preview(event: any) {
    const files = event.target.files;
    if (files.length === 0) {
      return;
    }
    this.logService.info(this.constructor.name, `image type must be jpg, user selected: ${files[0].type}`);

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    ImageUtils.resizeImage({
      file: files[0],
      maxSize: 1600,
    })
      .then((resizedImage: Blob) => {
        const objectUrl = window.URL.createObjectURL(resizedImage);
        this.imgURL = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
        this.imageBlobChange.emit(resizedImage);
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  imgOnLoad(event) {
    if (this.expectedOrientation == "Landscape" && event.target.width < event.target.height) {
      this.imgURL = null;
      this.imageBlobChange.emit(null);
      this.cd.detectChanges();
      alert(this.expectedOrientationMessage);
      this.imageButton.nativeElement.click();
    }
  }

  delete() {
    this.imgURL = null;
    this.imageBlobChange.emit(null);
  }
}
